import React from 'react';
import { Flex } from '@rebass/grid/emotion';

export const Grid = props => <Flex {...props} />;

Grid.defaultProps = {
  flexWrap: 'wrap',
};
